import React from 'react';
import {Button, ButtonGroup, Container, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
// import bannerImage from '../../../assests/images/banner.png'
import bannerImage from '../../../assests/images/BGHero.jpg'
import {useHistory, Link} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    bannerContainer: {
        maxHeight: '400px',
        overflow: "hidden",
        position:'relative',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    bannerContent: {
        overflow: 'hidden',
        paddingTop: '72px',
        textAlign: "left",
        color: '#ffffff',
        position: 'relative',
        zIndex: '9',
        [theme.breakpoints.up('md')] : {
            paddingBottom: '72px',
        },
        [theme.breakpoints.down('sm')] : {
            paddingBottom: '52px',
        },
        [theme.breakpoints.down('xs')] : {
            padding: '43px 15px 41px',
        },

    },
    heading: {
       fontSize: '48px',
       fontWeight: "bold",
        [theme.breakpoints.down('xs')] : {
            fontSize: '32px',
            lineHeight: '32px',
            fontWeight: 'normal',
            maxWidth: '100%',
        },
    },
    desc: {
      opacity: '70%',
      maxWidth: '684px',
      lineHeight: '24px',
      marginTop: '16px',
      marginBottom: '24px',
      [theme.breakpoints.down('xs')] : {
        fontSize: '14px',
        lineHeight: '18px',
        letterSpacing: '0.11px',
        maxWidth: '100%',
    },
    },
    button: {
        fontSize: '16px',
        padding: '12px 10px',
        borderRadius: '0',
        marginRight: '20px',
        lineHeight: '24.72px',
        letterSpacing: '0.11px',
        [theme.breakpoints.down('xs')] : {
            display: 'block',
            marginBottom: '12px'
        },
    },
    btnGroup: {
        [theme.breakpoints.down('xs')] : {
            display: 'block',
        },
    },
    buyticket: {
        color: theme.palette.text.primary,
        textDecoration: 'none',
    }
}));
export default function Banner({data}){
    const classes = useStyles();
    let history = useHistory();
    return <div className={classes.bannerContainer} style={{ backgroundImage: `url(${bannerImage})` }}>
        <Container maxWidth={'lg'} className={classes.bannerContent}>
            <Typography component="h2" className={classes.heading}>
                {data.title}
            </Typography>
            <p className={classes.desc}>
                {data.instruction}
            </p>
            <ButtonGroup className={classes.btnGroup}>
                <Button className={`${classes.button} secondary-btn`} color={'secondary'} variant={'contained'} onClick={()=>history.push({
                    pathname: `/schedule`,
                })}>{data.scheduleButton.title}</Button>
                <Button  onClick={()=>window.open(data.buyTicketsBtn.url, "_blank")} className={`${classes.button} get-ticket`} color={'inherit'} variant={'outlined'} style={{margin: '0'}}>
                    {data.buyTicketsBtn.title}
                </Button>
            </ButtonGroup>
        </Container>
    </div>
}